export default "__VITE_ASSET__BmvKZXUZ__"